'use client'

import { Chip } from '@wartek-id/chip'
import { Text } from '@wartek-id/text'

interface ChipProps {
  activeChips: string[]
  onClick: (str: string) => void
}

export const KabKotChips = ({ activeChips, onClick }: ChipProps) => {
  return (
    <div className="mt-4 flex items-center gap-2">
      <Text>Lihat Berdasarkan:</Text>
      <Chip
        isActive={activeChips.includes('kab')}
        onClick={() => {
          onClick('kab')
        }}
        data-testid="kab-chip"
      >
        Kabupaten
      </Chip>
      <Chip
        isActive={activeChips.includes('kot')}
        onClick={() => {
          onClick('kot')
        }}
        data-testid="kota-chip"
      >
        Kota
      </Chip>
    </div>
  )
}
